import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallText from '../../../common-components/common-small-text';

const Ciphers = () => {
    return (
        <ScrollAnimation delay={0} animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper smallPaddings={true} caseName="rec-ciphers">
                <div className="rec-ciphers__wrapper">
                    <CommonTitle className="rec-ciphers__title">Цифры</CommonTitle>
                    <div className="rec-ciphers__data-container">
                        <ScrollAnimation
                            delay={100}
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="rec-ciphers__data-item"
                        >
                            <div className="rec-ciphers__data-title">11</div>
                            <CommonSmallText className="rec-ciphers__data-subtitle">
                                субъектов, по которым велась работа
                            </CommonSmallText>
                            <img
                                src="/images/svg/rec/rec-ciphers__data-img1.svg"
                                alt=""
                                className="rec-ciphers__data-img"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                        <ScrollAnimation
                            delay={200}
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="rec-ciphers__data-item"
                        >
                            <div className="rec-ciphers__data-title">+33%</div>
                            <CommonSmallText className="rec-ciphers__data-subtitle">
                                рост поисковой выдачи в&nbsp;Яндексе
                            </CommonSmallText>
                            <img
                                src="/images/svg/rec/rec-ciphers__data-img2.svg"
                                alt=""
                                className="rec-ciphers__data-img"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                        <ScrollAnimation
                            delay={300}
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="rec-ciphers__data-item"
                        >
                            <div className="rec-ciphers__data-title">+5 500</div>
                            <CommonSmallText className="rec-ciphers__data-subtitle">
                                поискового трафика ежемесячно
                            </CommonSmallText>
                            <img
                                src="/images/svg/rec/rec-ciphers__data-img3.svg"
                                alt=""
                                className="rec-ciphers__data-img"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Ciphers;
